import React, { FC } from 'react';
import * as StyledResultItem from './resultItem.styles';

interface Props {
	headline: string;
	url: string;
	text: string;
}

const ResultItem: FC<Props> = ({ headline, url, text }) => {
	return (
		<StyledResultItem.ResultItem>
			<StyledResultItem.Headline>
				<StyledResultItem.HeadlineLink to={url}>{headline}</StyledResultItem.HeadlineLink>
			</StyledResultItem.Headline>
			{text && <StyledResultItem.Text>{text}</StyledResultItem.Text>}
			<StyledResultItem.UrlLink to={url}>{url}</StyledResultItem.UrlLink>
		</StyledResultItem.ResultItem>
	);
};

export default ResultItem;
